import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UICopyInput from 'UIComponents/input/UICopyInput';
import { Text } from 'foundations-components/components/Text';
import { getCommerceHomeUrl, getWebsitesURL } from 'growth-payments-core/urls/urls';
import Confetti from 'growth-onboarding-confetti/Confetti';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UseCaseTourCompleteModal = ({
  onClose,
  websiteLink
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "useCaseTourCompleteModal",
    use: "conversational",
    width: 500,
    onEsc: onClose,
    children: [/*#__PURE__*/_jsx(Confetti, {
      pieces: 60
    }), /*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetTop: 120,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "success"
      })
    }), /*#__PURE__*/_jsxs(UIDialogHeader, {
      className: "p-top-1 p-bottom-4",
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        "data-test-id": "useCaseTourCompleteModal-close",
        onClick: onClose
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "useCaseTourCompleteModal.header"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(Text, {
        as: "div",
        textAlign: "start",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "useCaseTourCompleteModal.messagePublished"
        }), /*#__PURE__*/_jsx(Text, {
          paddingBlockStart: "200",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "useCaseTourCompleteModal.messageFindAll_jsx",
            options: {
              href: getWebsitesURL(),
              external: true
            },
            elements: {
              Link: UILink
            }
          })
        }), /*#__PURE__*/_jsxs(Text, {
          as: "div",
          paddingBlockStart: "500",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "useCaseTourCompleteModal.shareLink.message"
          }), /*#__PURE__*/_jsx(UICopyInput, {
            className: "m-top-2",
            value: websiteLink
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        justify: "center",
        direction: "column",
        wrap: "wrap",
        children: /*#__PURE__*/_jsx(UILink, {
          "data-test-id": "useCaseTourCompleteModal-backToGuide",
          href: getCommerceHomeUrl(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "useCaseTourCompleteModal.backToCommerce"
          })
        })
      })
    })]
  });
};
export default UseCaseTourCompleteModal;